import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {BelegDTO} from '../../openapi/beleg-openapi';


@Injectable({
  providedIn: 'root'
})
export class EditFormService {

  private beleg$ = new BehaviorSubject<BelegDTO | undefined>(undefined);

  constructor() {
  }

  set beleg(beleg: BehaviorSubject<BelegDTO | undefined>) {
    this.beleg$ = beleg;
  }

  get beleg(): BehaviorSubject<BelegDTO | undefined> {
    return this.beleg$;
  }
}
